import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

export default defineComponent(OnlineStatus);

function OnlineStatus() {
    var currentUserId,
        users = {};

    this.attributes({
        requestUpdateEvent: 'dataRequestUpdateUserStatus',
        publishUpdateEvent: 'dataPublishUpdateUserStatus',
        updateEvent: 'uiUpdateUserStatus',
        timeOutInMinutes: 5,
        pollingInterval: 60000,
        authToken: null,
    });

    this.after('initialize', function() {
        this.setupData();

        this.on(this.attr.requestUpdateEvent, this.updateUsers);
        this.on(this.attr.publishUpdateEvent, this.publishUserUpdates);

        this.trigger(this.attr.requestUpdateEvent);

        window.setInterval(() => {
            if (document.hasFocus()) {
                this.trigger(this.attr.requestUpdateEvent);
            }
        }, this.attr.pollingInterval);

        $(window).on('focus', () => this.trigger(this.attr.requestUpdateEvent));
    });

    this.setupData = function() {
        currentUserId = this.$node.attr('data-user');
        if (this.$node.attr('data-project-participants')) {
            var userEndpoints = $.parseJSON(this.$node.attr('data-project-participants'));

            for (var id in userEndpoints) {
                if (userEndpoints.hasOwnProperty(id)) {
                    users[id] = {
                        endpoint: userEndpoints[id],
                        state: null,
                    };
                }
            }
        } else {
            users = {};
        }
    };

    this.updateUsers = function() {
        for (var id in users) {
            if (id !== currentUserId && users.hasOwnProperty(id)) {
                this.checkUserStatus(id, users[id].endpoint);
            }
        }
    };

    this.checkUserStatus = function(userId, endpoint) {
        this.request(endpoint).done(
            function(result) {
                var state = this.isUserOnline(new Date(result.time)) ? 'online' : 'offline';
                this.updateUser(userId, state);
            }.bind(this)
        );
    };

    this.updateUser = function(userId, state) {
        if (users[userId].state !== state) {
            users[userId].state = state;
            this.publishUserUpdate(userId);
        }
    };

    this.publishUserUpdates = function() {
        for (var id in users) {
            if (id !== currentUserId && users.hasOwnProperty(id)) {
                this.publishUserUpdate(id);
            }
        }
    };

    this.publishUserUpdate = function(userId) {
        this.trigger(this.attr.updateEvent, { id: userId, action: users[userId].state });
    };

    this.isUserOnline = function(lastSeen) {
        var d = new Date();
        d.setMinutes(d.getMinutes() - this.attr.timeOutInMinutes);

        return lastSeen >= d;
    };

    this.request = function(url) {
        return $.ajax({
            url: url,
            dataType: 'json',
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + this.attr.authToken);
            }.bind(this),
        });
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/data/online-status.js